/* eslint-disable no-param-reassign */
import React from 'react';
import isEqual from 'lodash/isEqual';
import isObject from 'lodash/isObject';
import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash/cloneDeep';
import propTypes from 'prop-types';
import moment from 'moment';
import InboundDetails from './InboundDetails/InboundDetails.component';
import Layout from '../layout';
import ProductDetails from './ProductDetails/ProductDetails.component';
import EditProductDetails from './ProductDetails/EditInboundProductDetails.component';
import Instructions from './Instructions.component';
import UI from '../ui';
import Utils from '../utils';
import { AllCarriers } from '../data/carriers';
import TrackingInfo from './Tracking/TrackingInfo.component';
import { Instructions as InstructionsData } from './Instructions';
import ShippingDetails from './ShippingDetails/ShippingDetails.component';
import { ShippingStatus, InboundStatus } from './Status';
import ConfirmInboundModal from './ConfirmInboundModal.component';
import ModalModule from '../modal';
import { ValidationErrors } from './Validations';

const { ModalContext } = ModalModule;
const { Session, Validation } = Utils;
const { WrappedButton, WrappedButtonType, WrappedCheckbox, WrappedTooltip } = UI;
const { LayoutContext, RegionType } = Layout;
class CreateEditInbound extends React.Component {
	constructor(props) {
		super(props);

		const { inbound, checkForSavedEditedInbound } = props;
		const { status } = inbound;
		const { ShowInboundInstructions } = Session.getPreferences();
		const validations = this.getDefaultValidation(inbound);
		const editedIndex = checkForSavedEditedInbound(inbound.inboundId);
		let newInbound = true;
		let showInstructionsUserPref = false;

		if (isEmpty(ShowInboundInstructions)) {
			showInstructionsUserPref = inbound.status === InboundStatus.Draft;
		} else {
			showInstructionsUserPref = ShowInboundInstructions === '1';
		}

		if (editedIndex !== -1) {
			newInbound = false;
		}

		this.state = {
			validations: inbound.shouldValidate
				? this.validateInbound(validations, true, false).newValidations
				: validations,
			editingInbound: cloneDeep(inbound),
			isNewInbound: newInbound,
			termsChecked:
				status === InboundStatus.Completed ||
				status === InboundStatus.Cancelled ||
				status === InboundStatus.Processing,
			showInstructions: showInstructionsUserPref,
			productHeader: InstructionsData.headers.default.product,
			inboundHeader: InstructionsData.headers.default.inbound,
			shippingHeader: InstructionsData.headers.default.shipping,
			productInstructions: InstructionsData.instructions.default.product,
			inboundInstructions: InstructionsData.instructions.default.inbound,
			shippingInstructions: InstructionsData.instructions.default.shipping,
		};
	}

	componentDidUpdate(prevProps) {
		const { inbound } = this.props;

		// refresh selected Inbound data
		if (!isEqual(prevProps.inbound.inboundId, inbound.inboundId)) {
			this.refreshInboundData(inbound);
		}
	}

	getDefaultValidation = inbound => {
		const purchaseOrderValidation =
				inbound.purchaseOrderNumber && inbound.purchaseOrderNumber.length > 10 ? -1 : 1,
			referenceValidation = inbound.reference && inbound.reference.length > 20 ? -1 : 1;
		let arrivalValidation = 0;

		if (inbound.expectedArrivalDate !== '') {
			const isValidArrivalDate = Validation.isValidDate(inbound.expectedArrivalDate);
			arrivalValidation = isValidArrivalDate ? 1 : -1;
		} else {
			arrivalValidation = 0;
		}

		return {
			warehouse: inbound.warehouseId ? 1 : 0,
			purchaseOrderNumber: purchaseOrderValidation,
			reference: referenceValidation,
			packingMethod: inbound.packagingType ? 1 : 0,
			shippingMethod: inbound.shippingMethod ? 1 : 0,
			arrival: arrivalValidation,
			shipFrom: inbound.shippingMethod === ShippingStatus.Self || inbound.fromAddress ? 1 : 0,
			product: {},
			tracking: {},
			termsCheckbox: 0,
		};
	};

	// save edited inbound
	saveInbound = (updatedValues, hasChanges = true) => {
		const { editingInbound } = this.state;
		const { updateEditingInbound } = this.props;
		const clonedInbound = cloneDeep(editingInbound);
		const updatedInbound = { ...clonedInbound, ...updatedValues };

		updatedInbound.shouldValidate = true;

		this.setState({
			editingInbound: { ...updatedInbound },
		});

		updateEditingInbound(updatedInbound, hasChanges);
	};

	updateValidation = updatedValidations => {
		this.setState({
			validations: updatedValidations,
		});
	};

	validateInbound = (validations, isValid, termsChecked) => {
		const newValidations = validations;

		// eslint-disable-next-line no-restricted-syntax
		for (const key in validations) {
			if (isObject(validations[key])) {
				const updatedValidation = this.validateInbound(
					validations[key],
					isValid,
					termsChecked
				);
				newValidations[key] = updatedValidation.newValidations;
				isValid = updatedValidation.isValid;
			} else if (key === 'termsCheckbox') {
				newValidations[key] = termsChecked ? 1 : -1;
				isValid = termsChecked ? isValid : false;
			} else if (validations[key] === 0) {
				newValidations[key] = -1;
				isValid = false;
			} else if (validations[key] === -1) {
				isValid = false;
			}
		}

		return {
			newValidations,
			isValid,
		};
	};

	// Check if the Inbound is valid(has all the required fields) and terms is checked then create Inbound
	onConfirmButtonClick = () => {
		const { deleteDraft, closeInboundFlow } = this.props;
		const { editingInbound, validations, termsChecked } = this.state;
		const { showModal } = this.context;
		const updatedValidation = this.validateInbound(validations, true, termsChecked);
		const successCallback = () => {
			if (editingInbound.status === InboundStatus.Draft) {
				deleteDraft(editingInbound.inboundId, true);
			}
			setTimeout(() => closeInboundFlow(true), 1000);
		};

		this.setState({
			validations: updatedValidation.newValidations,
		});

		if (updatedValidation.isValid) {
			showModal({
				component: ConfirmInboundModal,
				data: {
					editingInbound,
					onSuccess: successCallback,
				},
			});
		}
	};

	onSaveDraftButtonClick = () => {
		const { editingInbound } = this.state;
		const { closeInboundFlow, saveSelectedInbound } = this.props;

		saveSelectedInbound(editingInbound);
		closeInboundFlow();
	};

	onCancelButtonClick = () => {
		const { closeInboundFlow, deleteDraft } = this.props;
		const { editingInbound, isNewInbound } = this.state;

		if (editingInbound.status === InboundStatus.Draft && isNewInbound) {
			deleteDraft(editingInbound.inboundId, true);
		}

		closeInboundFlow();
	};

	onTermsCheckboxClick = () => {
		const { validations, termsChecked } = this.state;
		const updatedValidations = validations;

		this.setState(prevState => ({
			termsChecked: !prevState.termsChecked,
		}));

		updatedValidations.termsCheckbox = !termsChecked ? 1 : -1;
		this.updateValidation(updatedValidations);
	};

	onInstructionsCheckboxClick = () => {
		this.setState(prevState => {
			const updatedValue = !prevState.showInstructions;
			Session.savePreferences([
				{
					Name: 'ShowInboundInstructions',
					Value: updatedValue ? '1' : '0',
				},
			]);
			return {
				showInstructions: updatedValue,
			};
		});
	};

	updateInstructions = (section, header, instructions) => {
		if (section === 'product') {
			this.setState({
				productHeader: header,
				productInstructions: instructions,
			});
		} else if (section === 'inbound') {
			this.setState({
				inboundHeader: header,
				inboundInstructions: instructions,
			});
		} else if (section === 'shipping') {
			this.setState({
				shippingHeader: header,
				shippingInstructions: instructions,
			});
		}
	};

	// refresh editingProduct data if product data has changed
	refreshInboundData = inbound => {
		const { validations, termsChecked } = this.state;
		const { checkForSavedEditedInbound } = this.props;
		const editedIndex = checkForSavedEditedInbound(inbound.inboundId);
		const { ShowInboundInstructions } = Session.getPreferences();
		let newInbound = true;
		let showInstructionsUserPref = false;

		if (editedIndex !== -1) {
			newInbound = false;
		}

		if (isEmpty(ShowInboundInstructions)) {
			showInstructionsUserPref = inbound.status === InboundStatus.Draft;
		} else {
			showInstructionsUserPref = ShowInboundInstructions === '1';
		}

		this.setState({
			editingInbound: { ...inbound },
			isNewInbound: newInbound,
			showInstructions: showInstructionsUserPref,
		});

		// If validations is the same as what is in state, this is a newly created inbound
		// and should use default validation. Else, validate as existing inbound
		if (!isEmpty(inbound)) {
			if (inbound.shouldValidate) {
				const updatedValidation = this.validateInbound(validations, true, termsChecked);
				this.updateValidation(updatedValidation.newValidations);
			} else {
				this.updateValidation(this.getDefaultValidation(inbound));
			}
		}
	};

	getCarrierOptions = () => {
		const carrierOptions = [];

		Object.entries(AllCarriers).forEach(([, value]) => {
			let carrierName = value.displayName;

			if (value.key === 'GlobalPost') {
				return;
			}

			if (value.key === 'DHLExpress') {
				carrierName = 'DHL eCommerce';
			}

			carrierOptions.push({
				label: carrierName,
				id: value.id,
			});
		});

		carrierOptions.push({
			label: 'Other',
			id: 0,
		});

		return carrierOptions;
	};

	renderEditInboundStatus = () => {
		const {
			editingInbound: { lastModifiedDate, status },
		} = this.state;

		return (
			<div className="inbound-status-wrapper">
				<p className="status">
					<span className="status-label">Status: </span>
					{InboundStatus[status]}
				</p>
				<p className="date-updated">
					Updated {moment(lastModifiedDate).format('dddd, MMMM D, YYYY hh:mm A')}
				</p>
			</div>
		);
	};

	render() {
		const { products } = this.props;
		const {
			editingInbound,
			termsChecked,
			showInstructions,
			productHeader,
			inboundHeader,
			shippingHeader,
			productInstructions,
			inboundInstructions,
			shippingInstructions,
			validations,
		} = this.state;

		const { shippingMethod, status, receivingId } = editingInbound;
		const headerTitle =
			// eslint-disable-next-line no-nested-ternary
			status === InboundStatus.Draft
				? 'Create Inbound'
				: status === InboundStatus.Completed || status === InboundStatus.Cancelled
				? `Inbound - ${receivingId}`
				: `Edit Inbound - ${receivingId}`;

		return (
			<LayoutContext.Consumer>
				{layoutContext => {
					const { isMobile, getRegionWidth } = layoutContext;
					const mobileClassName = isMobile ? 'mobile' : '';
					const showMobileView = isMobile || getRegionWidth(RegionType.East) < 550;
					const showInbndDtlsMobileView = getRegionWidth(RegionType.East) < 660;

					return (
						<div className={`common-create-inbound ${mobileClassName}`}>
							<div className="inbound-details-header">
								{headerTitle}
								{status !== InboundStatus.Completed &&
									status !== InboundStatus.Cancelled && (
										<div className="instructions-checkbox">
											<WrappedCheckbox
												name="instructionsCheckbox"
												checked={showInstructions}
												onChange={this.onInstructionsCheckboxClick}
												dataqa="instructionscheckbox"
											>
												<p className="footer-text">Show Instructions</p>
											</WrappedCheckbox>
										</div>
									)}
							</div>

							{status !== InboundStatus.Draft && this.renderEditInboundStatus()}

							<div className="inbound-details-content">
								{showInstructions && (
									<Instructions
										region="product"
										title={productHeader}
										helperText={productInstructions}
										panelWidth={getRegionWidth(RegionType.East)}
									/>
								)}

								{status === InboundStatus.Completed ||
								status === InboundStatus.Cancelled ||
								status === InboundStatus.Processing ? (
									<EditProductDetails
										editingInbound={editingInbound}
										showMobileView={showMobileView}
									/>
								) : (
									<ProductDetails
										editingInbound={editingInbound}
										products={products}
										showMobileView={showMobileView}
										isMobile={isMobile}
										saveInbound={this.saveInbound}
										updateInstructions={this.updateInstructions}
										validations={validations}
										updateValidation={this.updateValidation}
									/>
								)}

								{showInstructions && (
									<Instructions
										region="inbound"
										title={inboundHeader}
										helperText={inboundInstructions}
										panelWidth={getRegionWidth(RegionType.East)}
									/>
								)}
								<InboundDetails
									inbound={editingInbound}
									showMobileView={showInbndDtlsMobileView}
									isMobile={isMobile}
									saveInbound={this.saveInbound}
									updateInstructions={this.updateInstructions}
									panelWidth={getRegionWidth(RegionType.East)}
									validations={validations}
									updateValidation={this.updateValidation}
								/>
								{showInstructions && (
									<Instructions
										region="shipping"
										title={shippingHeader}
										helperText={shippingInstructions}
										panelWidth={getRegionWidth(RegionType.East)}
									/>
								)}
								<ShippingDetails
									editingInbound={editingInbound}
									showMobileView={showMobileView}
									isMobile={isMobile}
									saveInbound={this.saveInbound}
									updateInstructions={this.updateInstructions}
									validations={validations}
									updateValidation={this.updateValidation}
									shippingHeader={shippingHeader}
								/>
								{shippingMethod === ShippingStatus.Self && (
									<TrackingInfo
										carrierOptions={this.getCarrierOptions()}
										editingInbound={editingInbound}
										showMobileView={showMobileView}
										isMobile={isMobile}
										saveInbound={this.saveInbound}
										updateInstructions={this.updateInstructions}
										validations={validations}
										updateValidation={this.updateValidation}
									/>
								)}
							</div>

							{status !== InboundStatus.Completed &&
								status !== InboundStatus.Cancelled && (
									<div className="inbound-details-footer">
										{status !== InboundStatus.Processing && (
											<div className="terms-checkbox">
												<WrappedCheckbox
													className={`${
														validations.termsCheckbox === -1
															? 'checkbox-error'
															: ''
													}`}
													name="termsCheckbox"
													checked={termsChecked}
													onChange={this.onTermsCheckboxClick}
													dataqa="termscheckbox"
												>
													<p className="footer-text">
														I agree that these products meet the
														<span> </span>
														<a
															href="https://www.zorbit.com/terms "
															target="_blank"
															rel="noopener noreferrer"
														>
															Zorbit Terms of Service
														</a>
														.
													</p>
												</WrappedCheckbox>
												{validations.termsCheckbox === -1 && !isMobile && (
													<div className="terms-error-container">
														<div className="invalid-error-icon terms-error-icon" />
														<WrappedTooltip
															target="terms-error-icon"
															position="right"
															className="tooltip-error"
															tooltip={
																ValidationErrors.termsCheckboxRequired
															}
														/>
													</div>
												)}
												{validations.termsCheckbox === -1 && isMobile && (
													<div className="terms-error-container">
														<div className="invalid-error-icon" />
														<span className="error-msg">
															{ValidationErrors.termsCheckboxRequired}
														</span>
													</div>
												)}
											</div>
										)}
										<div className="footer-buttons-wrapper">
											<WrappedButton
												buttonType={WrappedButtonType.Primary}
												label={
													status === InboundStatus.Draft
														? 'Confirm'
														: 'Update'
												}
												onClick={this.onConfirmButtonClick}
												dataqa="confirm-button"
											/>
											{status === InboundStatus.Draft && (
												<WrappedButton
													buttonType={WrappedButtonType.Primary}
													className="save-draft-button"
													label="Save as Draft"
													onClick={this.onSaveDraftButtonClick}
													dataqa="save-as-draft-button"
												/>
											)}
											<WrappedButton
												buttonType={WrappedButtonType.Secondary}
												className="discard-changes-button"
												label="Discard Changes"
												onClick={this.onCancelButtonClick}
												dataqa="discard-changes-button"
											/>
										</div>
									</div>
								)}
						</div>
					);
				}}
			</LayoutContext.Consumer>
		);
	}
}

CreateEditInbound.propType = {
	inbound: propTypes.object.isRequired,
	products: propTypes.array.isRequired,
	saveSelectedInbound: propTypes.func,
	closeInboundFlow: propTypes.func,
};

CreateEditInbound.contextType = ModalContext;

export default CreateEditInbound;
